import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UNLOGGED } from "util/constants";
import Representation from "./Representation";

const MarketIntelligencePreviewPage = ({ authenticated, user, theme = "dark" }) => {
  const history = useHistory();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (authenticated === UNLOGGED) {
      history.push("/");
    }
  }, [authenticated, history]);

  return <Representation user={user} theme={theme} language={i18n.language} />;
};

export default MarketIntelligencePreviewPage;
